import { call, takeLatest, put, select } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { fetchChooseCampaigns } from 'api/ExperimentsAPI';
import { Saga } from 'custom-types/saga';
import { addNegativeToast } from 'modules/toastContainer';
import {
  getChooseCampaignTableInfo,
  getChooseCampaignSearch,
  getChooseCampaignSortBy,
  getChooseCampaignSortDirection,
} from 'modules/experiments/ducks/selectors';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import {
  OriginalExperimentState,
  ExperimentTakeoverAction,
  FetchChooseCampaignResponse,
} from 'modules/experiments/takeover/types';
import { fetchChooseCampaignResponse } from 'modules/experiments/ducks/actions';
import { CHOOSE_CAMPAIGN_SORT_ENUM_LOOKUP } from 'modules/experiments/constants';
import { CHOOSE_CAMPAIGN_COLUMNS } from 'modules/experiments/types';

export function* fetchChooseCampaignSaga(): Saga<
  ExperimentTakeoverAction<Record<string, unknown>, OriginalExperimentState>
> {
  try {
    const { limit, offset } = yield select(getChooseCampaignTableInfo);
    const search = yield select(getChooseCampaignSearch);
    const sortBy: CHOOSE_CAMPAIGN_COLUMNS = yield select(getChooseCampaignSortBy);
    const sortEnum = CHOOSE_CAMPAIGN_SORT_ENUM_LOOKUP[sortBy];
    const sortDirection = yield select(getChooseCampaignSortDirection);

    const fetchCampaignVariables = {
      offset,
      limit,
      search,
      sortBy: sortEnum,
      sortDirection,
    };
    const { data }: { data: FetchChooseCampaignResponse } = yield call(
      fetchChooseCampaigns,
      fetchCampaignVariables,
    );
    yield put(fetchChooseCampaignResponse(data.campaigns)) as any;
  } catch (error) {
    yield put(addNegativeToast('Unable to fetch campaigns. Please try again later.') as any);
  }
}

addToRootSaga([
  takeLatest(ActionTypes.OPEN_CHOOSE_CAMPAIGN, fetchChooseCampaignSaga),
  takeLatest(ActionTypes.REFETCH_CAMPAIGNS, fetchChooseCampaignSaga),
]);
